<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1600"
      :mask-closable="false"
      title="导入通用套餐"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <import-carrier-product-search @submit="submitSearch" />

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ this.tableData.length }} 条记录，已选中 {{ this.selectedRowKeys.length }} 条数据
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { importCarrierProducts } from '@/api/carrier_product'
import { findImportableBaseCarrierProducts } from '@/api/base_carrier_product'
import { findCarrierType } from '@/api/carrier_account'
import ImportCarrierProductSearch from '@/views/carrier_products/import/Search'

export default {
  name: 'ImportCarrierProduct',
  components: { ImportCarrierProductSearch },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    carrierAccountId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      selectedRowKeys: [],
      carrierType: '',
      query: {},
      submitting: false,
      tableColumns: [
        {
          title: '通用套餐名称',
          dataIndex: 'name',
          width: 320,
          className: 'import-product-name'
        },
        {
          title: '流量场景',
          width: 120,
          dataIndex: 'traffic_scene'
        },
        {
          title: '标签',
          width: 100,
          dataIndex: 'tags'
        },
        {
          title: '共享属性',
          width: 150,
          dataIndex: 'traffic_share_property'
        },
        {
          title: '服务周期',
          width: 150,
          dataIndex: 'service_cycle'
        },
        {
          title: '套餐容量',
          width: 150,
          dataIndex: 'package_capacity'
        },
        {
          title: '语音',
          width: 100,
          dataIndex: 'voice_capacity'
        }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    findCarrierType(this.carrierAccountId).then((res) => {
      if (res.code === 0) {
        this.carrierType = res.data.carrier_type
        this.fetchData()
        return
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    fetchData() {
      if (!this.carrierType) {
        return
      }
      this.loading = true
      this.selectedRowKeys = []
      findImportableBaseCarrierProducts(Object.assign({}, this.query, {
        carrier_type: this.carrierType
      })).then((res) => {
        this.tableData = res.data
        this.loading = false
      })
    },

    submitSearch(search) {
      this.query = search
      this.fetchData()
    },

    handleSubmit() {
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      if (this.selectedRowKeys.length === 0) {
        this.$warning({
          title: '请选择操作对象',
          content: ''
        })
        return
      }

      const data = {
        carrier_account_id: this.carrierAccountId,
        base_carrier_product_ids: this.selectedRowKeys
      }

      this.submitting = true
      importCarrierProducts(data).then((res) => {
        if (res.code === 0) {
          // 关闭模态框
          this.isShow = false
          // 告知父组件已完成
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}

::v-deep .import-product-name {
  white-space: normal;
  word-break: break-word;
}
</style>
